import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { modelOf } from '../../../prop-types';
import ProductStore from '../../../store/ProductStore';
import ProductList from '../ProductList';
import { paramsToQueryIdentifier } from '../../../util/query';
import ProductListTools from '../ProductListTools';
import ConfigStore from '../../../store/ConfigStore';
import SimpleProductList from '../SimpleProductList';
import UIStore from '../../../store/UIStore';

@observer
export class TabProductList extends Component {
  getQueryIdentifier = () => paramsToQueryIdentifier(this.props.searchParams);

  getCurrentSearchResult = () =>
    this.props.productStore.productQueryResults.get(this.getQueryIdentifier());

  onStyleSelect = (style) => this.props.configStore.setProductListStyle(style);

  render() {
    const {
      configStore,
      productStore,
      uiStore,
      searchParams,
      name,
      listComponent,
      completeListingLink,
      preloadOnly,
      singleRowMode,
      requireCanonicalLink,
      ...rest
    } = this.props;

    if (!productStore || !searchParams) {
      return null;
    }

    const result = this.getCurrentSearchResult();

    return (
      <div className="TabProductList">
        {result &&
          !preloadOnly && (
            <div className="TabProductList__active-filter-row">
              <ProductListTools
                showSort={false}
                onStyleSelect={this.onStyleSelect}
                style={configStore.productListStyle}
                countOfProducts={result.total}
              />
              {completeListingLink}
            </div>
          )}
        <SimpleProductList
          searchParams={searchParams}
          name={name}
          style={configStore.productListStyle}
          listComponent={listComponent}
          completeListingLink={
            result && result.total > result.data.length
              ? completeListingLink
              : null
          }
          preloadOnly={preloadOnly}
          singleRowMode={singleRowMode}
          requireCanonicalLink={requireCanonicalLink}
          {...rest}
        />
      </div>
    );
  }
}

TabProductList.propTypes = {
  configStore: modelOf(ConfigStore).isRequired,
  productStore: modelOf(ProductStore).isRequired,
  uiStore: modelOf(UIStore).isRequired,
  searchParams: PropTypes.object.isRequired,
  name: PropTypes.string,
  listComponent: PropTypes.func,
  completeListingLink: PropTypes.node,
  preloadOnly: PropTypes.bool,
  singleRowMode: PropTypes.bool,
  requireCanonicalLink: PropTypes.bool
};

TabProductList.defaultProps = {
  listComponent: ProductList,
  preloadOnly: false,
  disableQuickSearch: false,
  singleRowMode: false,
  requireCanonicalLink: false
};

export default inject('productStore', 'configStore', 'uiStore')(TabProductList);



// WEBPACK FOOTER //
// ./src/components/product-list/TabProductList/index.jsx